import React, { createContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  const [user, setUser] = useState(null);
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [authTokens, setAuthTokens] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const accessToken = localStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token");
    console.log("AuthContext - Stored user:", storedUser);
    console.log("AuthContext - Stored access token:", accessToken);
    console.log("AuthContext - Stored refresh token:", refreshToken);

    if (accessToken) {
      setIsSignedIn(true);
      setAuthTokens({
        access: accessToken,
        refresh: refreshToken,
      });
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        console.log("AuthContext - Parsed user:", parsedUser);
        setUser(parsedUser);
      }
    } else {
      setIsSignedIn(false);
      setAuthTokens(null);
    }
  }, []);

  const fetchFullUser = async (token) => {
    try {
      const response = await fetch(`${SERVER_URL}/auth/users/me/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.ok) {
        const fullUser = await response.json();
        localStorage.setItem("user", JSON.stringify(fullUser));
        setUser(fullUser);
      } else {
        console.error("Failed to fetch user details:", response.status);
      }
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  const login = (userData, accessToken, refreshToken) => {
    console.log("AuthContext - Logging in with userData:", userData);
    const tokens = { access: accessToken, refresh: refreshToken };
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("access_token", accessToken);
    localStorage.setItem("refresh_token", refreshToken);
    setUser(userData);
    setAuthTokens(tokens);
    setIsSignedIn(true);

    // If first_name is missing, fetch it
    if (!userData.first_name) {
      fetchFullUser(accessToken);
    }
  };

  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setUser(null);
    setAuthTokens(null);
    setIsSignedIn(false);
  };

  return (
    <AuthContext.Provider
      value={{ user, isSignedIn, authTokens, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
